
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.475 2.31a4.171 4.171 0 00-4.167 4.167v2.5h-.833c-.92 0-1.667.748-1.667 1.667v6.666c0 .92.748 1.667 1.667 1.667h10c.919 0 1.666-.747 1.666-1.667v-6.666c0-.92-.747-1.667-1.666-1.667h-.834v-2.5a4.171 4.171 0 00-4.166-4.167zm5 8.334l.001 6.666H5.475v-6.666h10zm-7.5-1.667v-2.5c0-1.378 1.121-2.5 2.5-2.5 1.378 0 2.5 1.122 2.5 2.5v2.5h-5z","fill":"#80A0AF"}})])
          )
        }
      }
    